import _classCallCheck from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { BaseRequestPolicy } from "./requestPolicy";
/**
 * Creates a policy that signs outgoing requests by calling to the provided `authenticationProvider`'s `signRequest` method.
 * @param authenticationProvider - The authentication provider.
 * @returns An instance of the {@link SigningPolicy}.
 */

export function signingPolicy(authenticationProvider) {
  return {
    create: function create(nextPolicy, options) {
      return new SigningPolicy(nextPolicy, options, authenticationProvider);
    }
  };
}
/**
 * A policy that signs outgoing requests by calling to the provided `authenticationProvider`'s `signRequest` method.
 */

export var SigningPolicy = /*#__PURE__*/function (_BaseRequestPolicy) {
  _inherits(SigningPolicy, _BaseRequestPolicy);

  function SigningPolicy(nextPolicy, options, authenticationProvider) {
    var _this;

    _classCallCheck(this, SigningPolicy);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SigningPolicy).call(this, nextPolicy, options));
    _this.authenticationProvider = authenticationProvider;
    return _this;
  }

  _createClass(SigningPolicy, [{
    key: "signRequest",
    value: function signRequest(request) {
      return this.authenticationProvider.signRequest(request);
    }
  }, {
    key: "sendRequest",
    value: function sendRequest(request) {
      var _this2 = this;

      return this.signRequest(request).then(function (nextRequest) {
        return _this2._nextPolicy.sendRequest(nextRequest);
      });
    }
  }]);

  return SigningPolicy;
}(BaseRequestPolicy);